
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { MsalGuardConfiguration, MsalInterceptorConfiguration, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-common';
import { AuthConfig } from './app/model/auth-config';

const isIE =
  window.navigator.userAgent.indexOf('MSIE') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

export function MSALGuardConfigFactory(authConfig: AuthConfig): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: authConfig.scopes,
    },
    loginFailedRoute: './'
  }
}

export function MsalInstanceFactory(authConfig: AuthConfig): PublicClientApplication {
  console.log('print authConfig');
  console.log(authConfig);
  return new PublicClientApplication({
    auth: {
      clientId: authConfig.clientId,
      authority: authConfig.signUpSignIn.authority,
      redirectUri: authConfig.redirectUri,
      postLogoutRedirectUri: authConfig.postLogoutRedirectUri,
      knownAuthorities: [authConfig.authorityDomain]
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE
    },
    system: {
      allowNativeBroker: false, // Disables native brokering support
      loggerOptions: {
        loggerCallback: (logLevel, message) => {
          //console.log(message);
        },
        //logLevel: LogLevel.Error,
        piiLoggingEnabled: true,
        

      }
    }
  },
  )
}

export function MSALInterceptorConfigFactory(authConfig: AuthConfig): MsalInterceptorConfiguration {
  const rootApiUrl = `${getBaseUrl()}api`
  const protectedResourceMap = new Map<string, Array<string> | null>();
  protectedResourceMap.set(rootApiUrl, authConfig.scopes);
    
  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap,
  };
}


if (environment.production) {
  enableProdMode();
}

fetch('./api/spaclientsettings/authentication')
  .then(response => response.json())
  .then(json => {
    console.log('spa client setting');
    console.log(json);
    const authConfig = new AuthConfig(json);
    authConfig.redirectUri = authConfig.redirectUri ?? getBaseUrl();
    authConfig.postLogoutRedirectUri = authConfig.postLogoutRedirectUri ?? getBaseUrl();    
    const providers = [
      { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
      { provide: AuthConfig, useValue: authConfig },
      {
        provide: MSAL_INSTANCE, useFactory: MsalInstanceFactory, deps: [AuthConfig]
      },
      { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory, deps: [AuthConfig] },
      {
        provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory, deps: [AuthConfig]
      }
    ]

    platformBrowserDynamic(providers)
      .bootstrapModule(AppModule)
      .catch(err => console.log(err));

  })  
  .catch (error => console.error('Failed to load authentication settings:', error));
  ;
